export default __webpack_public_path__ + "assets/haze.4a31f4dd.svg";